import { render, staticRenderFns } from "./CartaoPrincipal.vue?vue&type=template&id=72e5c584&scoped=true"
import script from "./CartaoPrincipal.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoPrincipal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoPrincipal.vue?vue&type=style&index=0&id=72e5c584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e5c584",
  null
  
)

export default component.exports